import * as React from "react";
import { scrollListItemIntoView } from "~/sharedComponents/advancedEditor/utils/scrollListItemIntoView";
import { ResourceGroupRow } from "~/sharedComponents/listRows/ResourcesListRow";
import { TeamListRow } from "~/sharedComponents/listRows/TeamListRow";
import { UserListRow } from "~/sharedComponents/listRows/UserListRow";
import { MentionSuggestionItem } from "../types";
import * as styles from "./baseMentionTheme.less";

export type MentionEntryProps = {
    mention: MentionSuggestionItem;
    theme: any;
    searchValue: string;
    isFocused: boolean;
};

export const MentionEntry = (props: MentionEntryProps) => {
    const { mention, theme, searchValue, isFocused, ...parentProps } = props;

    const ref = React.useRef(null as HTMLDivElement);
    React.useEffect(() => {
        if (isFocused) {
            scrollListItemIntoView(ref.current);
        }
    }, [isFocused]);

    const isTeam = !!mention.teamId;

    const item = {
        Name: mention.title,
        UserId: mention.id,
        TeamId: mention.teamId,
    };

    return (
        <>
            {!!mention.group && <ResourceGroupRow item={mention.group} className={styles.group} />}
            <div {...parentProps} ref={ref}>
                {isTeam ? (
                    <TeamListRow item={item} isFocused={isFocused} textForHighlight={searchValue} />
                ) : (
                    <UserListRow item={item} isFocused={isFocused} textForHighlight={searchValue} />
                )}
            </div>
        </>
    );
};
